import { Box } from "@mui/material";
import Header from "../../../components/Header";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
    modifyCurrency,
    getCurrencysError,
    getCurrencysStatus,
    getCurrencysLoading,
    getCurrencysSuccess,
} from "../../../features/currencySlice";
import { useLocation, useNavigate } from "react-router-dom";
import BackButton from "../../../components/backButton";
import CurrencyForm from "./currencyForm";
import RestaurantAppBar from "../../../components/restaurantTopBar";
import { useTranslation } from "react-i18next";

const ModifyCurrency = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const data = location.state.currency;
    const status = useSelector(getCurrencysStatus);
    const error = useSelector(getCurrencysError);
    const loading = useSelector(getCurrencysLoading);
    const success = useSelector(getCurrencysSuccess);

    const initialValues = {
        name: data.name ?? "",
        code: data.code ?? "",
        symbol: data.symbol ?? "",
    };

    const handleFormSubmit = (values) => {
        const requestBody = {
            name: values.name,
            code: values.code,
            symbol: values.symbol,
        };
        dispatch(modifyCurrency({ body: requestBody, currencyId: data._id }))
    };

    useEffect(() => {
        if (status === "modifySuccess") {
            navigate("/currency-management");
            toast.success(success);
        } else if (status === "modifyError") {
            toast.error(error);
        }
    }, [status, error, dispatch, navigate, success]);

    return (
        <div className="main-application">
            <RestaurantAppBar />
            <Box m="20px" className="main-application">
                <BackButton />
                <Header title={t("headers.editCurrencyPage")} subtitle={t("headers.editCurrencyPageSub")} />
                <CurrencyForm
                    buttonText={t("common.submit")}
                    handleFormSubmit={handleFormSubmit}
                    initialValues={initialValues}
                    loading={loading}
                />
            </Box>
        </div>
    );
};

export default ModifyCurrency;
